import { InlineAlert, UniversalPageLayout } from "../components/BaseComponents";

// Public search is withheld for everyone until its replacement is built; the top-bar search still lands here with `?s=`.
function PublicProfiles() {
    return (
        <UniversalPageLayout
            heading={{ title: 'Public Profiles and Disclosures' }}
            documentTitle='Public Profiles and Disclosures'
        >
            <InlineAlert type='info' data-testid='public-search-holding'>
                We are enhancing our search engine – this feature will be reinstated in a future update. You will
                be able to search publicly available emissions data for countries, organisations, industry
                sectors, and products.
            </InlineAlert>
        </UniversalPageLayout>
    )
}

export default PublicProfiles;
